import type { AppEnvironment } from './types';
import { IP4CMS_PAGE_COPY } from './page-copy-ip4cms';

/**
 * FADT (Fidelity ADT) member app — STAGING, single-tenant (NOT SSO).
 *
 * Same backend as the ip4cms vertical (core-api / api .ip4cms-staging.ip4x.systems),
 * pinned to the freshly-seeded `fadt` tenant
 * (f9442b4e-0159-4d81-a1d5-be6cac14a26d) via its member domain. Served from
 * `dist/fadt-staging` and wrapped as a dedicated native app (com.sudosky.fadt).
 *
 * Mirrors the sbmdc-staging pattern: direct single-tenant build (`rootTenantId: ''`,
 * `authMode: 'tenant'`) — no SSO scope, no community switcher. Renders from the
 * shared DCApp template (fbb54d26) sent as x-app-template-id.
 */
export const env: AppEnvironment = {
  production: true,
  buildMode: 'fadt-staging',
  apiBaseUrl: 'https://api.ip4cms-staging.ip4x.systems/v1',
  coreApiUrl: 'https://core-api.ip4cms-staging.ip4x.systems/v1',
  // Shared "DCApp" member app template (code `dcapp`) owned by the ip4cms tenant.
  appTemplateId: 'fbb54d26-d0e8-4f98-99cf-7ca377ab0a72',
  push: { enabled: true },
  authMode: 'tenant',
  portalOwnerType: 'member',
  loadDomainConfig: true,
  defaultDomain: 'fadt.member.ip4cms-staging.ip4x.systems',
  rootTenantId: '',
  portalBaseUrl: 'https://fadt.member.ip4cms-staging.ip4x.systems',
  appName: 'Fidelity ADT',
  version: '1.0.0',
  appShell: 'classic',
  keyboardShift: true,
  welcomeContent: {
    eyebrow: 'Fidelity ADT',
    title: 'Your community,\nin your pocket.',
    subtitle: 'Access, services and your home — all in one place.',
  },
  communitySelectContent: {
    title: 'Choose your community',
    subtitle: 'Search for the community you live in to begin registration.',
  },
  signupTermsUrl: 'https://www.glovent.co.za/terms',
  pageCopy: { ...IP4CMS_PAGE_COPY },
  home: {
    widgetMode: true,
    widgets: [
      { id: 'account', type: 'account', title: 'Account', order: 1, enabled: true, requiresModule: 'financials' },
      { id: 'support', type: 'support', title: 'Helpdesk', order: 2, enabled: true, requiresModule: 'support' },
      { id: 'events', type: 'events', title: 'Upcoming events', order: 3, enabled: true, requiresModule: 'events' },
      { id: 'panic', type: 'panic', title: 'Emergency', order: 4, enabled: true, requiresModule: 'panic' },
      { id: 'utilities', type: 'utilities', title: 'Utilities', order: 5, enabled: true, requiresModule: 'utilities' },
      { id: 'access', type: 'access', title: 'Visitor access', order: 6, enabled: true, requiresModule: 'access_management' },
      { id: 'news', type: 'news', title: 'News', order: 7, enabled: true, requiresModule: 'newsstand' },
    ],
  },
};
